module.exports = new __parcel__URL__("pvp_defeat_icon_label.768a562c.png").toString();